import * as React from "react";
import { useQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_RECOMMENDATIONS } from "../../operations/queries/operations/queries/get-recommendations.js";
import { mergeAndSortRecommendations } from "../../utils/utils/merge-and-sort-recommendations.js";
const useProductRecommendation = ({
  recommendationContext,
  skus
}) => {
  const { locale } = useIntl();
  const { data, loading: isLoading } = useQuery(
    GET_RECOMMENDATIONS,
    {
      variables: {
        input: {
          skus,
          recommendationContext,
          locale
        }
      }
    }
  );
  const recommendedProducts = React.useMemo(
    () => data?.getRecommendations?.recommendedProducts || [],
    [data?.getRecommendations]
  );
  const recommendedBanners = React.useMemo(
    () => data?.getRecommendations?.recommendedBanners || [],
    [data?.getRecommendations]
  );
  return React.useMemo(
    () => ({
      isLoading,
      recommendations: mergeAndSortRecommendations(recommendedProducts, recommendedBanners) || []
    }),
    [recommendedProducts, recommendedBanners, isLoading]
  );
};
export {
  useProductRecommendation
};
//# sourceMappingURL=use-product-recommendation.js.map
